import gql from "graphql-tag";

export const NEW_COMPANY_CREATION_FOR_USER = gql`
  mutation NewCompanyCreationForUser {
    newCompanyCreationForUser {
      id
    }
  }
`;
